import React, { CSSProperties, FC, ReactNode } from 'react'

import cn from 'classnames'

import classes from './card.module.scss'

export interface CardProps {
  cardId?: string
  header?: ReactNode
  children: ReactNode
  cardType?: 'default' | 'help' | 'error'
  wrapperClassName?: string | Record<string, boolean>
  customWrapperStyle?: CSSProperties
  className?: string | Record<string, boolean>
  footer?: ReactNode
  id?: string
  style?: CSSProperties
  noPadding?: boolean
  addSpacing?: boolean
  noMargin?: boolean
  dataTestId?: string
}

export const Card: FC<CardProps> = ({
  cardId,
  header,
  children,
  cardType = 'default',
  wrapperClassName,
  customWrapperStyle,
  className,
  footer,
  id,
  style,
  noPadding,
  addSpacing,
  noMargin,
  dataTestId = 'card',
}) => {
  const cardItemClasses = cn(
    classes.cardItem,
    {
      [classes.hasHeader]: !!header,
      [classes.hasFooter]: !!footer,
      [classes.noPadding]: !!noPadding,
      [classes.addSpacing]: !!addSpacing,
      [classes.cardTypeHelp]: cardType === 'help',
      [classes.cardTypeError]: cardType === 'error',
    },
    className
  )

  const wrapperClasses = cn(
    classes.wrapper,
    {
      [classes.noMargin]: noMargin !== undefined,
    },
    wrapperClassName
  )

  return (
    <div
      className={wrapperClasses}
      style={customWrapperStyle}
      id={id}
      data-card={cardId}
    >
      {header}
      <div className={cardItemClasses} style={style} data-testid={dataTestId}>
        {children}
      </div>
      {footer}
    </div>
  )
}

export default Card
